export const BLACK_USER_ENDPOINTS = {
  add: '/tax/v1/risk/black/user/add',
  edit: '/tax/v1/risk/black/user/edit',
  enable: '/tax/v1/risk/black/user/enable',
  disable: '/tax/v1/risk/black/user/disable',
  delete: '/tax/v1/risk/black/user/delete',
};

const ENABLED_STATUS = new Set(['009', 'enable', 'enabled', '启用']);

export function isEnabled(row = {}) {
  return ENABLED_STATUS.has(String(row.enableStatus == null ? '' : row.enableStatus).toLowerCase());
}

export function clickVisible({ row = {}, val = {} }) {
  const code = typeof val === 'string' ? val : (val.code || val.buttonCode);
  if (code === 'enable') return !isEnabled(row);
  if (code === 'disable') return isEnabled(row);
  return true;
}

export function operateBlackUser({
  code, row, selection = [], request, onSuccess, onEmpty,
}) {
  const endpoint = BLACK_USER_ENDPOINTS[code];
  if (!endpoint) return Promise.reject(new Error(`Unsupported black user operation: ${code}`));

  if (code === 'edit' || code === 'add') {
    if (!row || typeof row !== 'object' || Object.keys(row).length === 0) {
      if (onEmpty) onEmpty();
      return Promise.resolve({ success: false, skipped: true });
    }
    return request.post(endpoint, row).then((res) => {
      if (res.success && onSuccess) onSuccess(res);
      return res;
    });
  }

  const ids = row && row.id !== undefined && row.id !== null
    ? [row.id]
    : selection.filter((id) => id !== undefined && id !== null);

  if (!ids.length) {
    if (onEmpty) onEmpty();
    return Promise.resolve({ success: false, skipped: true });
  }

  return request.post(endpoint, ids).then((res) => {
    if (res.success && onSuccess) onSuccess(res);
    return res;
  });
}
